<!-- <sm-title-bar [pageTitle]="interestType == '0' ? 'Home service' : (interestType == '1' ? 'In-premise' : (interestType == '2' ? 'Virtual service ' : 'All activity '))  " [backWithParams]="true" 
[headerCustomTemplate]="addButton">
<ng-template #addButton>
   <div class="booking_sectionkl" *ngIf="interestType == '4'">
      <div class="Create_header_btn">
        <button [matMenuTriggerFor]="menu" mat-icon-button color="primary" > <mat-icon>add</mat-icon></button>
     </div>
     <mat-menu #menu="matMenu">
      <button  mat-menu-item (click)="createNewBookingFromList()">
        <mat-icon class="material-icons-outlined">view_list</mat-icon>
        <span>New Booking</span>
      </button>
      <button  mat-menu-item (click)="addNewInterestFromList()">
        <mat-icon class="material-icons-outlined">article_shortcut</mat-icon>
        <span>New Query</span>
      </button>
    </mat-menu>
    </div>
   <div class="booking_sectionkl" *ngIf="interestType == '4'">
      <div class="date-range-form">
          <div class="nw_all">
          <mat-form-field appearance="outline">
            <mat-label>From Date</mat-label>
            <input matInput [matDatepicker]="fromDatePicker" [(ngModel)]="fromDate" readonly>
            <mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #fromDatePicker></mat-datepicker>
          </mat-form-field>
       </div>
       <div class="nw_all">
          <mat-form-field appearance="outline">
            <mat-label>To Date</mat-label>
            <input matInput [matDatepicker]="toDatePicker" [(ngModel)]="toDate" readonly>
            <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #toDatePicker></mat-datepicker>
          </mat-form-field>
          </div>
          <div class="search_pag">
          <button mat-flat-button color="primary" type="submit" (click)="onSearch()">Search</button>
      </div>
    </div>
  </div>
   <div class="booking_sectionkl" *ngIf="interestType != '4'">
      <div class="Create_header_btn">
        <button [matMenuTriggerFor]="menu" mat-icon-button color="primary" > <mat-icon>add</mat-icon></button>
     </div>
     <mat-menu #menu="matMenu">
      <button  mat-menu-item (click)="createNewBooking()">
        <mat-icon class="material-icons-outlined">view_list</mat-icon>
        <span>New Booking</span>
      </button>
      <button  mat-menu-item (click)="addNewInterest()">
        <mat-icon class="material-icons-outlined">article_shortcut</mat-icon>
        <span>New Query</span>
      </button>
    </mat-menu>
     <div class="booking_sedr">
      <button mat-icon-button color="primary" (click)="refresh()">
        <mat-icon class="material-icons-round" [inline]="true" style="font-size: 22px; position: relative; top: 0px;">refresh</mat-icon>
    </button>
    </div>
    </div>
</ng-template>
</sm-title-bar> -->


<div class="rest_dra">
  <div class="frm_date_dra">
    <div class="page-title-bar flex-sm-row flex-column flex-wrap d-flex justify-content-between align-items-start">
     <div class="title d-flex justify-content-between align-items-center w-100">
  <div class="d-flex align-items-center">
    <button mat-icon-button class="me-3" (click)="navigate()">
      <mat-icon class="material-icons-round">arrow_back</mat-icon>
    </button>
    <div>
      <h1 class="mb-0">{{interestType == '0' ? 'Home service' : (interestType == '1' ? 'In-premise' : (interestType == '2' ? 'Virtual service ' : 'All activity '))}}</h1>
      <!-- <h2 class="m-0">ada</h2> -->
    </div>
  </div>
  <div class="booking_sectionkl" [ngStyle]="{'top': interestType != '4' ? '10px' : '0px' }" style="display: flex;    position: relative;" *ngIf="interestType == '4'">
      <div class="Create_header_btn">
        <button *ngIf="isAccessForEmployeeInvoice" [matMenuTriggerFor]="menu" mat-icon-button color="primary" > <mat-icon>add</mat-icon></button>
     </div>
     <mat-menu #menu="matMenu">
      <button  mat-menu-item (click)="createNewBookingFromList()">
        <mat-icon class="material-icons-outlined">event</mat-icon>
        <span>New booking</span>
      </button>
      <button  mat-menu-item (click)="addNewInterestFromList()">
        <mat-icon class="material-icons-outlined">card_membership</mat-icon>
        <span>New membership request</span>
      </button>
    </mat-menu>
    </div>
     <div class="booking_sectionkl" style="display: flex;     position: relative;
    top: 10px;" *ngIf="interestType != '4'">
      <div class="Create_header_btn">
        <button [matMenuTriggerFor]="menu" mat-icon-button color="primary" > <mat-icon>add</mat-icon></button>
     </div>
     <mat-menu #menu="matMenu">
      <button  mat-menu-item (click)="createNewBooking()">
        <mat-icon class="material-icons-outlined">event</mat-icon>
        <span>New booking</span>
      </button>
      <button  mat-menu-item (click)="addNewInterest()">
        <mat-icon class="material-icons-outlined">card_membership</mat-icon>
        <span>New membership request</span>
      </button>
    </mat-menu>
     <div class="booking_sedr">
      <button mat-icon-button color="primary" (click)="refresh()">
        <mat-icon class="material-icons-round" [inline]="true" style="font-size: 22px; position: relative; top: 0px;">refresh</mat-icon>
    </button>
    </div>
    </div>
</div>

    <div class="date-range-form" *ngIf="interestType == '4'">
        <div class="nw_all">
          <mat-form-field appearance="outline" (click)="fromDatePicker.open()">
            <mat-label>From Date</mat-label>
            <input matInput [matDatepicker]="fromDatePicker" [(ngModel)]="fromDate" readonly>
            <mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #fromDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="nw_all">
          <mat-form-field appearance="outline" (click)="toDatePicker.open()">
            <mat-label>To Date</mat-label>
            <input matInput [matDatepicker]="toDatePicker" [(ngModel)]="toDate" readonly>
            <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #toDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="search_pag">
          <button mat-flat-button color="primary" type="submit" (click)="onSearch()">{{ 'booking_history.search' |
            translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>




<div class="chip_cont">
   <div class="booing_sectyy">

       <div class="booing_sectyy">   
      <mat-chip-listbox aria-label="Fish selection" class="mb-1" *ngIf="interestType != '4'">
         <mat-chip
         (click)="changeChip('0')"
         [ngClass]="{'Graceful-box-active': selectedValue == '0' && processType == 2}"
         >Today
         </mat-chip>
      </mat-chip-listbox>
      <mat-chip-listbox aria-label="Fish selection" class="mb-1" *ngIf="interestType != '4'">
         <mat-chip
         (click)="changeChip('1')"
         [ngClass]="{'Graceful-box-active': selectedValue == '1' && processType == 2}"
        >Tomorrow
         </mat-chip>
      </mat-chip-listbox>
      <mat-chip-listbox aria-label="Fish selection" class="mb-1" *ngIf="interestType == '4'">
         <mat-chip
         (click)="changeChip('3')"
         [ngClass]="{'Graceful-box-active': selectedValue == '3' && processType == 3}"
        >Attendance
         </mat-chip>
      </mat-chip-listbox>
      <mat-chip-listbox aria-label="Fish selection" class="mb-1" *ngIf="interestType == '4'">
         <mat-chip
         (click)="changeChip('2')"
         [ngClass]="{'Graceful-box-active': selectedValue == '2' && processType == 3}"
        >Session booking
         </mat-chip>
      </mat-chip-listbox>
      <mat-chip-listbox aria-label="Fish selection" class="mb-1">
         <mat-chip
         (click)="changeInterestStatus('1')"
         [ngClass]="{'Graceful-box-active': interestStatus == '1' && processType == 1}"
         >Membership request
         </mat-chip>
      </mat-chip-listbox>
      <mat-chip-listbox aria-label="Fish selection" class="mb-1">
         <mat-chip
         (click)="changeInterestStatus('2')"
         [ngClass]="{'Graceful-box-active': interestStatus == '2' && processType == 1}"
         >Customer queries
         </mat-chip>
      </mat-chip-listbox>

   </div>

   </div>



</div>
  <!-- <div class="booking_sedr">
         <button mat-flat-button color="primary">
            <mat-icon class="material-icons-round" style="font-size: 22px; position: relative; top: 0px;">refresh</mat-icon>
         </button>
      </div> -->
<!-- <div *ngIf="loader" class="loader">
   <mat-spinner></mat-spinner>
</div> -->

<mat-form-field appearance="outline" *ngIf="!loader && interestType == '4' && processType == 1 && interestStatus == '1'">
   <mat-label>Search</mat-label>
   <input matInput placeholder="Search joining query list" [(ngModel)]="searchString" (keyup)="searchNameData()">
   <mat-icon matSuffix>search</mat-icon>
</mat-form-field>





<!-- MEMBERSHIP QUERIES START -->
<div class="busroy" *ngIf="!loader && interestData.length > 0  && processType == 1  && interestStatus == '1'">
   <div class="row">
      <div class="col-sm-4" *ngFor="let item of interestData" (click)="viewDetails(item)">
     <mat-card >
   <div class="booking-card" >
     <div class="booking-header">
       <div class="left-section" style="position: relative;">
         <mat-icon
         [class.new-booking]="item.enrollment_request_status == 1" [class.under-process]="item.enrollment_request_status == 2 " [class.completed]="item.enrollment_request_status == 5" [class.cancelled]="item.enrollment_request_status == 4 " [class.confirmed]="item.enrollment_request_status == 3"
             class="status-icon"></mat-icon>
          <div class="booking-initial" *ngIf="(!item.image_thumb_url || item.image_thumb_url == 'null')">{{item.customer_name.slice(0,1)}}</div>
          <img  class="booking-initial-img img-fluid rounded-circle" [src]="item.image_thumb_url" alt="" *ngIf="item.image_thumb_url && item.image_thumb_url != 'null'" onerror="this.src='../../../../assets/images/user-avatar.svg'">
          <div class="booking-details">
           <h3 class="booking-name">{{item.customer_name}}</h3>
           <p class="booking-number">  <span class="bookingstar" style="font-size: 14px;color: #888;">{{item.phone}}</span></p>
         </div>
       </div>


       <!-- <button mat-icon-button [matMenuTriggerFor]="menu" class="custom-icon-button">
         <mat-icon>more_vert</mat-icon>
       </button> -->
       <mat-menu #menu="matMenu">
         <button mat-menu-item (click)="viewDetails(item)">
            <mat-icon class="material-icons-outlined">info</mat-icon>
            <span>View details</span>
            </button>

         <button mat-menu-item (click)="addReply(item)" *ngIf="item.enrollment_request_status != 5 && ( interestType != '4')">
         <mat-icon class="material-icons-outlined">reply</mat-icon>
         <span>Reply</span>
         </button>
         <button mat-menu-item (click)="changeRequestStatus(item,1)" *ngIf="item.enrollment_request_status != 1 &&  item.enrollment_request_status != 5 && ( interestType != '4')">
         <mat-icon class="material-icons-outlined">grade</mat-icon>
         <span>Mark as new</span>
         </button>
         <button mat-menu-item (click)="changeRequestStatus(item,2)" *ngIf="item.enrollment_request_status != 2 &&  item.enrollment_request_status != 5 && ( interestType != '4')">
         <mat-icon class="material-icons-outlined">hourglass_top</mat-icon>
         <span>Mark as in-progress</span>
         </button>
         <button mat-menu-item (click)="changeRequestStatus(item,3)" *ngIf="item.enrollment_request_status != 3 &&  item.enrollment_request_status != 5 && ( interestType != '4')">
         <mat-icon class="material-icons-outlined">task_alt</mat-icon>
         <span>Mark as enrolled</span>
         </button>
         <button mat-menu-item (click)="changeRequestStatus(item,4)" *ngIf="item.enrollment_request_status != 4 &&  item.enrollment_request_status != 5 && ( interestType != '4')">
         <mat-icon class="material-icons-outlined">cancel</mat-icon>
         <span>Mark as cancelled</span>
         </button>
         <button mat-menu-item (click)="addAsMember(item)" *ngIf="item.enrollment_request_status == 3 &&  item.enrollment_request_status != 5 && ( interestType != '4')">
         <mat-icon class="material-icons-outlined">person_add</mat-icon>
         <span> Add in enrolled members</span>
         </button>

         <button mat-menu-item (click)="deleteQuery(item)" *ngIf="(!item.customer_account_hash ||  item.customer_account_hash == 'null') && (isOwner)">
         <mat-icon class="material-icons-outlined">delete</mat-icon>
         <span> Delete query</span>
         </button>
     </mat-menu>
     </div>
     
     
     <p class="booking-meta">
       <!-- <span class="label">Phone: </span> <span class="value"></span>,  -->
       <span class="label">Status: </span> <span class="value" >{{item.item_status}}</span>
     </p>
     <p class="booking-meta">
       <!-- <span class="label">Phone: </span> <span class="value"></span>,  -->
       <span class="label">Service mode: </span> <span class="value" >{{item.service_mode}}</span>
     </p>
     <p class="booking-meta">
        <span class="label">Services: </span>
        <span class="value">{{item.opted_services}} </span>
       <!-- <span class="value">{{item.bookingStartTime}} - {{item.bookingEndTime}}</span>  -->
     </p>
     <p class="booking-meta">
       <span class="value">{{item.creation_time | date}}</span>
     </p>
   </div>
     <div class="arrow_iocn_x">
    <mat-icon>arrow_forward</mat-icon>
  </div>
 </mat-card>
 </div>
 </div>
   </div>
 

<!-- placeholder html start -->
<div class="placeholder_started" *ngIf="!loader && interestData.length == 0  && processType == 1  && interestStatus == '1'">
   <div class="row">
      <div class="col-sm-4" *ngIf="interestStatus == '1'">
         <div class="dashboard_new">
            <mat-card appearance="outlined">
               <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/query-s1.jpg">
                  </div>
                  <mat-card-title>No queries to show.</mat-card-title>
                  <mat-card-content>All the queries will appear here between the selected date range. It seems you haven't started operations or check the selected dates.
                  </mat-card-content>
                  <div class="watch_vc_btn" *ngIf="interestType != '4'">
                     <button mat-stroked-button color="primary"  (click)="addNewInterest()">
                        <mat-icon>add</mat-icon>
                        Add new query 
                     </button>
                  </div>
               </div>
            </mat-card>
         </div>
      </div>

      <div class="col-sm-4">
         <div class="dashboard_new">
           <mat-card appearance="outlined">
               <div class="upload_sectio">
              <div class="icm_img">
                 <img src="/assets/images/new-booking.png">
              </div>
              <mat-card-title>How to create a new query?</mat-card-title>
              <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on creating new query against a business. You can check this video as well. 

             </mat-card-content>
             <div class="watch_vc_btn">
               <button mat-stroked-button color="primary" (click)="openvideo()">
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
               </button>
            </div>
              </div>
           </mat-card>
        </div>
       </div>
      <div class="col-sm-4">
         <div class="dashboard_new">
            <mat-card appearance="outlined">
               <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/helpsupport.png">
                  </div>
                  <mat-card-title>Facing any issue?</mat-card-title>
                  <mat-card-content>For any difficulties in adding a new query or issue with managing them, contact our support team.
                  </mat-card-content>
                  <div class="watch_vc_btn">
                     <button mat-stroked-button color="primary"  (click)="opencontact()">
                        <mat-icon>support_agent</mat-icon>
                        Contact support 
                     </button>
                  </div>
               </div>
            </mat-card>
         </div>
      </div>
   </div>
</div>
<!-- placeholder html end -->

<!-- MEMBERSHIP QUERIES END -->


<!-- -----------------TODAY TOMORROW START------------------------- -->



 <div class="busroy" *ngIf=" !loader && bookingsData.length > 0 && processType == 2">
  <div class="row">
   <div class="col-sm-4" *ngFor="let item of bookingsData" (click)="bookingDetails(item)">
   <mat-card >
   
      <div class="booking-card" >
     <div class="booking-header">
       <!-- <div class="left-section">
         <div class="booking-initial">{{item.customerName.slice(0,1)}}</div>
         <div class="booking-details">
           <h3 class="booking-name">{{item.customerName}}</h3>
           <h2 class="booking-number" *ngIf="item.appointment_no">#{{item.appointment_no}}</h2>
         </div>
       </div> -->
       <div class="left-section" style="position: relative;">
         <mat-icon
         *ngIf="item.data_type == 1"
         [class.new-booking]="(item.bookingStatus == 0 ||item.bookingStatus == 1 || item.bookingStatus == 2) && item.data_type == 1" [class.under-process]="(item.bookingStatus == 3 || item.bookingStatus == 7 || item.bookingStatus == 9) && item.data_type == 1" [class.completed]="item.bookingStatus == 4 && item.data_type == 1" [class.cancelled]="(item.bookingStatus == 6 || item.bookingStatus == 8) && item.data_type == 1" [class.confirmed]="item.bookingStatus == 5 && item.data_type == 1"
             class="status-icon"></mat-icon>
         <mat-icon
         *ngIf="item.data_type == 2"
         
         [class.cancelled]="(item.bookingStatus == 0 )&& item.data_type == 2"
         [class.new-booking]="(item.bookingStatus == 1 && !item.session_status ) && item.data_type == 2"
         [class.under-process]="(item.bookingStatus == 1 && (item.session_status ==  2 || item.session_status ==  1)) && item.data_type == 2"
         [class.completed]="(item.bookingStatus == 1 && item.session_status ==  3) && item.data_type == 2"
             class="status-icon"></mat-icon>
         
           <div class="booking-initial" *ngIf="(!item.customerInfo?.imgThumbUrl || item.customerInfo?.imgThumbUrl == 'null') && item.data_type == 1">{{item.customer_name.slice(0,1)}}</div>
         
           <div class="booking-initial" *ngIf="(!item.member_thumb_image || item.member_thumb_image == 'null') && item.data_type == 2">{{item.customer_name.slice(0,1)}}</div>
           
           <img  class="booking-initial-img img-fluid rounded-circle" [src]="item.customerInfo.imgThumbUrl" alt="" *ngIf="item.data_type == 1 && item.customerInfo.imgThumbUrl && item.customerInfo.imgThumbUrl != 'null'" onerror="this.src='../../../../assets/images/user-avatar.svg'">
         
           <img  class="booking-initial-img img-fluid rounded-circle" [src]="item.member_thumb_image" alt="" *ngIf="item.data_type == 2 && item.member_thumb_image && item.member_thumb_image != 'null'" onerror="this.src='../../../../assets/images/user-avatar.svg'">
         
           <div class="booking-details">
           <h3 class="booking-name">{{item.customer_name}}</h3>
           <!-- <h2 class="booking-number" *ngIf="item.appointment_no && item.appointment_no != '---'">#{{item.appointment_no}}</h2> -->
           <p class="booking-number">  <span class="bookingstar">{{item.bookingStartTime}} - {{item.bookingEndTime}}</span> <span *ngIf="item.data_type == 1 && item.appointment_no"><span style="color: #333;">,</span> #{{item.appointment_no}}</span></p>
         </div>
       </div>

       <!-- <button mat-icon-button [matMenuTriggerFor]="menu" class="custom-icon-button">
         <mat-icon>more_vert</mat-icon>
       </button> -->
       <mat-menu #menu="matMenu">
         <div *ngIf="item.data_type == 1">
            <!-- <button mat-menu-item *ngIf="((item.bookingStatus == 0 || item.bookingStatus == 1 || item.bookingStatus == 2) && (item.customerInfo.hash_id && item.customerInfo.hash_id != 'null') && (isOwner || interestType != '4'))" (click)="confirmBooking(item)">
              <mat-icon class="material-icons-outlined">check_circle</mat-icon>
              <span>{{ 'business_bookings.opt_confirm_booking' | translate }}</span>
            </button>
            <button mat-menu-item *ngIf="(item.bookingStatus == 0 || item.bookingStatus == 1 || item.bookingStatus == 2 || item.bookingStatus == 7 || item.bookingStatus == 9 || item.bookingStatus == 5) && (isOwner || interestType != '4') && selectedValue == '0' && processType == 2" (click)="startProcess(item)">
              <mat-icon class="material-icons-outlined">timer</mat-icon>
              <span>{{ 'business_bookings.opt_start_process' | translate }}</span>
            </button>
            <button mat-menu-item *ngIf="(item.bookingStatus == 0 || item.bookingStatus == 1 || item.bookingStatus == 2 || item.bookingStatus == 7 || item.bookingStatus == 9 || item.bookingStatus == 5) && isOwner && selectedValue == '0' && processType == 2" (click)="assignJob(item)">
              <mat-icon class="material-icons-outlined">assignment_ind</mat-icon>
              <span>{{ 'business_bookings.opt_assign_job' | translate }}</span>
            </button>
            
            <button mat-menu-item *ngIf="(item.bookingStatus == 3 || item.bookingStatus == 5) && selectedValue == '0' && processType == 2 && (isOwner || interestType != '4')" (click)="done(item)">
              <mat-icon class="material-icons-outlined">task_alt</mat-icon>
              <span>{{ 'business_bookings.opt_done' | translate }}</span>
            </button>
            <button mat-menu-item *ngIf="(item.bookingStatus == 3 || item.bookingStatus == 9 || item.bookingStatus == 4) && isOwner && selectedValue == '0' && processType == 2" (click)="customiseBooking(item)">
              <mat-icon class="material-icons-outlined">tune</mat-icon>
              <span>Edit data</span>
            </button>
            <button mat-menu-item *ngIf="(item.bookingStatus != 4 && item.bookingStatus != 6 && item.bookingStatus != 8) && bookingType == '2'" (click)="addEditMeetingData(item)">
      <mat-icon class="material-icons-outlined">video_chat</mat-icon>
      <span>Meeting info</span>
    </button>
            <button mat-menu-item *ngIf="(item.bookingStatus == 3 || item.bookingStatus == 9 || item.bookingStatus == 4) && isOwner && selectedValue == '0' && processType == 2" (click)="reset(item)">
              <mat-icon class="material-icons-outlined">restart_alt</mat-icon>
              <span>{{ 'business_bookings.opt_reset_to_new' | translate }}</span>
            </button> -->
            <button mat-menu-item *ngIf="item.bookingStatus == 0 || item.bookingStatus == 1 || item.bookingStatus == 2 || item.bookingStatus == 7 || item.bookingStatus == 3 || item.bookingStatus == 9 || item.bookingStatus == 4 || item.bookingStatus == 8 || item.bookingStatus == 6 || item.bookingStatus == 5" (click)="bookingDetails(item)">
              <mat-icon class="material-icons-outlined">info</mat-icon>
              <span>{{ 'business_bookings.opt_booking_details' | translate }}</span>
            </button>
            <!-- <button mat-menu-item *ngIf="item.bookingStatus == 4 && selectedValue == '0' && processType == 2 && (isOwner || interestType != '4')" (click)="openInvoice(item)">
              <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
              <span>{{ 'business_bookings.opt_invoice' | translate }}</span>
            </button>
            <button mat-menu-item *ngIf="((item.bookingStatus == 0 || item.bookingStatus == 1 || item.bookingStatus == 2 || item.bookingStatus == 5) && isOwner)" (click)="cancelBooking(item)">
              <mat-icon class="material-icons-outlined">cancel</mat-icon>
              <span>{{ 'business_bookings.opt_cancel_booking' | translate }}</span>
            </button>
            <button mat-menu-item *ngIf="(!item.customerInfo.hash_id || item.customerInfo.hash_id == 'null') && isOwner && selectedValue == '0' && processType == 2" (click)="deleteBooking(item)">
              <mat-icon class="material-icons-outlined">delete</mat-icon>
              <span>Delete booking</span>
            </button> -->
          </div>
            <div *ngIf="item.data_type == 2">
           
             <button mat-menu-item (click)="viewDetailsForMember(item)">
                <mat-icon class="material-icons-outlined">info</mat-icon>
                <span>View details</span>
                </button>
             <!-- <button mat-menu-item [disabled]="(processType == 2 && selectedValue == '1') || (!isOwner && interestType == '4')" (click)="changeAttendanceStatus(1,item)" *ngIf="item.bookingStatus == 0 || item.bookingStatus == null || item.bookingStatus == 'null'"> 
             <mat-icon class="material-icons-outlined">check_circle</mat-icon>
             <span>Mark as present</span>
             </button>
             <button mat-menu-item (click)="assignJobForMember(item)" *ngIf="item.bookingStatus == 1  && item.session_status != 3 && isOwner">
             <mat-icon class="material-icons-outlined">assignment_ind</mat-icon>
             <span>Assign job</span>
             </button>
             <button mat-menu-item (click)="operationForMember(item,2)" *ngIf="item.bookingStatus == 1 && item.session_status != 3 && item.session_status != 2">
             <mat-icon class="material-icons-outlined">timer</mat-icon>
             <span>Start job</span>
             </button>
             <button mat-menu-item (click)="operationForMember(item,3)" *ngIf="item.bookingStatus == 1 && item.session_status != 3">
             <mat-icon class="material-icons-outlined">task_alt</mat-icon>
             <span>Job done</span>
             </button>
             <button mat-menu-item [disabled]="(processType == 2 && selectedValue == '1') || (!isOwner && interestType == '4')" (click)="changeAttendanceStatus(0,item)" *ngIf="item.bookingStatus == null || item.bookingStatus == 'null'">
             <mat-icon class="material-icons-outlined">cancel</mat-icon>
             <span>Mark as absent</span>
             </button>
             <button mat-menu-item [disabled]="(processType == 2 && selectedValue == '1') || (!isOwner && item.session_status == 3) || (!isOwner && interestType == '4')" *ngIf="(item.bookingStatus == 0 || item.bookingStatus == 1) 
                        && (isOwner || item.session_status != 3)"  (click)="deleteAttendance(item)" [disabled]="">
             <mat-icon class="material-icons-outlined">delete</mat-icon>
             <span>Delete attendance</span>
             </button> -->



             <!-- <button mat-menu-item (click)="changeAttendanceStatus(1,data)" *ngIf="item.bookingStatus == 0 || item.bookingStatus == null || item.bookingStatus == 'null'">
               <mat-icon class="material-icons-outlined">check_circle</mat-icon>
               <span>mark as present</span>
               </button>
               <button mat-menu-item (click)="assignJobForMember(data)" *ngIf="item.bookingStatus == 1  && item.session_status != 3 && isOwner">
            <mat-icon class="material-icons-outlined">assignment_ind</mat-icon>
            <span>Assign job</span>
            </button>
               <button mat-menu-item (click)="operationForMember(data,2)" *ngIf="item.bookingStatus == 1 && item.session_status != 3 && item.session_status != 2">
            <mat-icon class="material-icons-outlined">timer</mat-icon>
            <span>Start job</span>
            </button>
               <button mat-menu-item (click)="operationForMember(data,3)" *ngIf="item.bookingStatus == 1 && item.session_status != 3">
               <mat-icon class="material-icons-outlined">task_alt</mat-icon>
               <span>Job done</span>
               </button>
               <button mat-menu-item (click)="changeAttendanceStatus(0,data)" *ngIf="item.bookingStatus == null || item.bookingStatus == 'null'">
               <mat-icon class="material-icons-outlined">cancel</mat-icon>
               <span>mark as absent</span>
               </button>
               <button mat-menu-item *ngIf="(item.bookingStatus == 0 || item.bookingStatus == 1) 
                        && (isOwner || item.session_status != 3)"  (click)="deleteAttendance(data)">
               <mat-icon class="material-icons-outlined">cancel</mat-icon>
               <span>Delete attendance</span>
               </button> -->
            
       
        </div>
     </mat-menu>
     </div>
     
    
     
     <p class="booking-meta">
       <span class="label">Assigned to: </span> <span class="value">{{item.employeeName}}</span>
     </p>
     <p class="booking-meta">
       <span class="label">Status: </span>
       <span class="value" >{{item.bookingStat}}</span> 
       <span class="label" *ngIf="item.paymentStat && item.paymentStat != '---'">, Payment: </span> <span class="value"  *ngIf="item.paymentStat && item.paymentStat != '---'">{{item.paymentStat}}</span>
     </p>
   <p class="date_booking">{{item.cust_phn}}
   </p>
   </div>

     <div class="arrow_iocn_x">
    <mat-icon>arrow_forward</mat-icon>
  </div>
</mat-card>
   
</div>
</div>
     
   </div>


 
 <ng-template #menuTemplate2 let-rowvalue>
   <div *ngIf="rowvalue.data_type == 1">
     <button mat-menu-item *ngIf="((rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2) && (rowvalue.customerInfo.hash_id && rowvalue.customerInfo.hash_id != 'null') && (isOwner || interestType != '4'))" (click)="confirmBooking(rowvalue)">
       <mat-icon class="material-icons-outlined">check_circle</mat-icon>
       <span>{{ 'business_bookings.opt_confirm_booking' | translate }}</span>
     </button>
     <button mat-menu-item *ngIf="(rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2 || rowvalue.bookingStatus == 7 || rowvalue.bookingStatus == 9 || rowvalue.bookingStatus == 5) && (isOwner || interestType != '4')" (click)="startProcess(rowvalue)">
       <mat-icon class="material-icons-outlined">timer</mat-icon>
       <span>{{ 'business_bookings.opt_start_process' | translate }}</span>
     </button>
     <button mat-menu-item *ngIf="(rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2 || rowvalue.bookingStatus == 7 || rowvalue.bookingStatus == 9 || rowvalue.bookingStatus == 5) && isOwner" (click)="assignJob(rowvalue)">
       <mat-icon class="material-icons-outlined">assignment_ind</mat-icon>
       <span>{{ 'business_bookings.opt_assign_job' | translate }}</span>
     </button>
     
     <button mat-menu-item *ngIf="rowvalue.bookingStatus == 3 && (isOwner || interestType != '4')" (click)="done(rowvalue)">
       <mat-icon class="material-icons-outlined">task_alt</mat-icon>
       <span>{{ 'business_bookings.opt_done' | translate }}</span>
     </button>
     <button mat-menu-item *ngIf="(rowvalue.bookingStatus == 3 || rowvalue.bookingStatus == 9 || rowvalue.bookingStatus == 4) && isOwner" (click)="customiseBooking(rowvalue)">
       <mat-icon class="material-icons-outlined">tune</mat-icon>
       <span>Edit data</span>
     </button>
      <button mat-menu-item *ngIf="(rowvalue.bookingStatus != 4 && rowvalue.bookingStatus != 6 && rowvalue.bookingStatus != 8) && bookingType == '2'" (click)="addEditMeetingData(rowvalue)">
      <mat-icon class="material-icons-outlined">video_chat</mat-icon>
      <span>Meeting info</span>
    </button>
     <button mat-menu-item *ngIf="(rowvalue.bookingStatus == 3 || rowvalue.bookingStatus == 9 || rowvalue.bookingStatus == 4) && isOwner" (click)="reset(rowvalue)">
       <mat-icon class="material-icons-outlined">restart_alt</mat-icon>
       <span>{{ 'business_bookings.opt_reset_to_new' | translate }}</span>
     </button>
     <button mat-menu-item *ngIf="rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2 || rowvalue.bookingStatus == 7 || rowvalue.bookingStatus == 3 || rowvalue.bookingStatus == 9 || rowvalue.bookingStatus == 4 || rowvalue.bookingStatus == 8 || rowvalue.bookingStatus == 6 || rowvalue.bookingStatus == 5" (click)="bookingDetails(rowvalue)">
       <mat-icon class="material-icons-outlined">info</mat-icon>
       <span>{{ 'business_bookings.opt_booking_details' | translate }}</span>
     </button>
     <button mat-menu-item *ngIf="rowvalue.bookingStatus == 4 && (isOwner || interestType != '4')" (click)="openInvoice(rowvalue)">
       <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
       <span>{{ 'business_bookings.opt_invoice' | translate }}</span>
     </button>
     <button mat-menu-item *ngIf="((rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2 || rowvalue.bookingStatus == 5) && isOwner)" (click)="cancelBooking(rowvalue)">
       <mat-icon class="material-icons-outlined">cancel</mat-icon>
       <span>{{ 'business_bookings.opt_cancel_booking' | translate }}</span>
     </button>
     <button mat-menu-item *ngIf="(!rowvalue.customerInfo.hash_id || rowvalue.customerInfo.hash_id == 'null') && isOwner" (click)="deleteBooking(rowvalue)">
       <mat-icon class="material-icons-outlined">delete</mat-icon>
       <span>Delete booking</span>
     </button>
   </div>
     <div *ngIf="rowvalue.data_type == 2">
    
      <button mat-menu-item (click)="viewDetailsForMember(rowvalue)">
         <mat-icon class="material-icons-outlined">info</mat-icon>
         <span>View details</span>
         </button>
      <button mat-menu-item [disabled]="(processType == 2 && selectedValue == '1') || (!isOwner && interestType == '4')" (click)="changeAttendanceStatus(1,rowvalue)" *ngIf="(rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == null || rowvalue.bookingStatus == 'null') && (rowvalue.session_status != 3)" > 
      <mat-icon class="material-icons-outlined">check_circle</mat-icon>
      <span>Mark as present</span>
      </button>
      <button mat-menu-item (click)="operationForMember(rowvalue,3)" *ngIf="rowvalue.bookingStatus == 1 && rowvalue.session_status == 2 && rowvalue.session_status != 3">
      <mat-icon class="material-icons-outlined">task_alt</mat-icon>
      <span>Job done</span>
      </button>
      <button mat-menu-item (click)="assignJobForMember(rowvalue)" *ngIf="rowvalue.bookingStatus == 1  && rowvalue.session_status != 3 && isOwner">
      <mat-icon class="material-icons-outlined">assignment_ind</mat-icon>
      <span>Assign job</span>
      </button>
      <button mat-menu-item (click)="operationForMember(rowvalue,2)" *ngIf="rowvalue.bookingStatus == 1 && rowvalue.session_status != 3 && rowvalue.session_status != 2">
      <mat-icon class="material-icons-outlined">timer</mat-icon>
      <span>Start job</span>
      </button>
      <button mat-menu-item [disabled]="(processType == 2 && selectedValue == '1') || (!isOwner && interestType == '4')" (click)="changeAttendanceStatus(0,rowvalue)" *ngIf="(rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == null || rowvalue.bookingStatus == 'null') && (rowvalue.session_status != 3)">
      <mat-icon class="material-icons-outlined">cancel</mat-icon>
      <span>Mark as absent</span>
      </button>
      <button mat-menu-item [disabled]="(processType == 2 && selectedValue == '1') || (!isOwner && rowvalue.session_status == 3) || (!isOwner && interestType == '4')" *ngIf="rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1" (click)="deleteAttendance(rowvalue)" [disabled]="">
      <mat-icon class="material-icons-outlined">delete</mat-icon>
      <span>Delete attendance</span>
      </button>
     

 </div>
   </ng-template> 
 
 
 
   <!-- placeholder html start -->
   <div class="placeholder_started" *ngIf="!loader && bookingsData.length == 0  && processType == 2">
         <div class="row">
           <div class="col-sm-4" *ngIf="selectedValue == '0'">
             <div class="dashboard_new">
               <mat-card appearance="outlined">
                   <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/bookings-pp.png">
                  </div>
                  <mat-card-title>No bookings for today.</mat-card-title>
                  <mat-card-content>There's no booking done by any customer or from the house for today. Though you can create one from here.
                 </mat-card-content>
                  <div class="watch_vc_btn">
                     <button mat-stroked-button color="primary" (click)="createNewBooking()">
                       <mat-icon>add</mat-icon>
                       New booking
                     </button>
                  </div>
                  </div>
               </mat-card>
            </div>
           </div>
           <div class="col-sm-4" *ngIf="selectedValue == '1'">
             <div class="dashboard_new">
               <mat-card appearance="outlined">
                   <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/bookings-pp.png">
                  </div>
                  <mat-card-title>No bookings for tomorrow.</mat-card-title>
                  <mat-card-content>There's no booking done by any customer or from the house for tomorrow. Though you can create one from here.
                 </mat-card-content>
                  <div class="watch_vc_btn">
                     <button mat-stroked-button color="primary" (click)="createNewBooking()">
                        <mat-icon>add</mat-icon>
                        New booking
                     </button>
                  </div>
                  </div>
               </mat-card>
            </div>
           </div>
           <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="/assets/images/new-booking.png">
                 </div>
                 <mat-card-title>How to create a new booking?</mat-card-title>
                 <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on creating new booking against a business. You can check this video as well. 

                </mat-card-content>
                <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="openvideo()">
                     <mat-icon>play_arrow</mat-icon>
                     Watch video
                  </button>
               </div>
                 </div>
              </mat-card>
           </div>
          </div>
           <div class="col-sm-4">
             <div class="dashboard_new">
               <mat-card appearance="outlined">
                   <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/helpsupport.png">
                  </div>
                  <mat-card-title>Facing any issue?</mat-card-title>
                  <mat-card-content>For any difficulties in creating a new booking or in issue in getting booking list data, contact our support team. 
                 </mat-card-content>
                  <div class="watch_vc_btn">
                     <button mat-stroked-button color="primary"  (click)="opencontact()">
                        <mat-icon>support_agent</mat-icon>
                        Contact support 
                     </button>
                  </div>
                  </div>
               </mat-card>
            </div>
           </div>
         </div>
   </div> 
   <!-- placeholder html end -->


<!-- -----------------TODAY TOMORROW END------------------------- -->

   <!-- --------SESSION BOOKINGS START -------------->
    



 <div class="busroy" *ngIf="!loader && messageList.length > 0 && processType == 3 && selectedValue == '2'">
      <div class="row">
         <div class="col-sm-4" *ngFor="let item of messageList" (click)="bookingDetailsForHistory(item)">
   <mat-card >
         <div class="booking-card" >
         <div class="booking-header">
            
            <div class="left-section" style="position: relative;">

               <mat-icon
               *ngIf="(!item.customerInfo.imgThumbUrl || item.customerInfo.imgThumbUrl == 'null') && item.data_type == 1"
               [class.new-booking]="(item.bookingStatus == 0 ||item.bookingStatus == 1 || item.bookingStatus == 2) && item.data_type == 1" [class.under-process]="(item.bookingStatus == 3 || item.bookingStatus == 7 || item.bookingStatus == 9)&& item.data_type == 1" [class.completed]="item.bookingStatus == 4 && item.data_type == 1" [class.cancelled]="(item.bookingStatus == 6 || item.bookingStatus == 8)&& item.data_type == 1" [class.confirmed]="item.bookingStatus == 5 && item.data_type == 1"
                  class="status-icon"></mat-icon>
               <mat-icon
               *ngIf="item.customerInfo.imgThumbUrl && item.customerInfo.imgThumbUrl != 'null' && item.data_type == 1"
               [class.new-booking]="(item.bookingStatus == 0 ||item.bookingStatus == 1 || item.bookingStatus == 2) && item.data_type == 1" [class.under-process]="(item.bookingStatus == 3 || item.bookingStatus == 7 || item.bookingStatus == 9)&& item.data_type == 1" [class.completed]="item.bookingStatus == 4 && item.data_type == 1" [class.cancelled]="(item.bookingStatus == 6 || item.bookingStatus == 8)&& item.data_type == 1" [class.confirmed]="item.bookingStatus == 5 && item.data_type == 1"
                  class="status-icon"></mat-icon>

               <mat-icon
               *ngIf="(!item.customerInfo.imgThumbUrl || item.customerInfo.imgThumbUrl == 'null') && item.data_type == 2"
               [class.cancelled]="(item.bookingStatus == 0 )&& item.data_type == 2"
         [class.new-booking]="(item.bookingStatus == 1 && !item.session_status ) && item.data_type == 2"
         [class.under-process]="(item.bookingStatus == 1 && (item.session_status ==  2 || item.session_status ==  1)) && item.data_type == 2"
         [class.completed]="(item.bookingStatus == 1 && item.session_status ==  3) && item.data_type == 2"
                  class="status-icon"></mat-icon>
               <mat-icon
               *ngIf="item.customerInfo.imgThumbUrl && item.customerInfo.imgThumbUrl != 'null' && item.data_type == 2"
               [class.cancelled]="(item.bookingStatus == 0 )&& item.data_type == 2"
         [class.new-booking]="(item.bookingStatus == 1 && !item.session_status ) && item.data_type == 2"
         [class.under-process]="(item.bookingStatus == 1 && (item.session_status ==  2 || item.session_status ==  1)) && item.data_type == 2"
         [class.completed]="(item.bookingStatus == 1 && item.session_status ==  3) && item.data_type == 2"
                  class="status-icon"></mat-icon>



               <div class="booking-initial" *ngIf="!item.customerInfo.imgThumbUrl || item.customerInfo.imgThumbUrl == 'null'">{{item.customerName.slice(0,1)}}</div>
               <img class="booking-initial-img img-fluid rounded-circle" [src]="item.customerInfo.imgThumbUrl" alt="" *ngIf="item.customerInfo.imgThumbUrl && item.customerInfo.imgThumbUrl != 'null'" onerror="this.src='../../../../assets/images/user-avatar.svg'">
               <div class="booking-details">
               <h3 class="booking-name">{{item.customerName}}</h3>

               <!-- <h2 class="booking-number" *ngIf="item.appointment_no">#{{item.appointment_no}}</h2> -->
               <p class="booking-number">  <span class="bookingstar">{{item.bookingStartTime}} - {{item.bookingEndTime}}, </span> <span *ngIf="item.data_type == 1 && item.appointment_no">#{{item.appointment_no}} </span></p>
               </div>
            </div>
            <!-- <button mat-icon-button [matMenuTriggerFor]="menu" class="custom-icon-button">
               <mat-icon>more_vert</mat-icon>
            </button> -->
            <mat-menu #menu="matMenu">
               <div *ngIf="item.data_type == 1">
                  <!-- <button mat-menu-item (click)="confirmBookingForHistory(item)" *ngIf="(((item.bookingStatus == 0 || item.bookingStatus == 1 || item.bookingStatus == 2) && (item.customerInfo.hash_id && item.customerInfo.hash_id != 'null')) && (item.toshowOptions == 1) && (isOwner || interestType != '4'))">
                     <mat-icon class="material-icons-outlined">check_circle</mat-icon>
                     <span>Confirm booking</span>
                  </button> -->
                  <button mat-menu-item (click)="bookingDetailsForHistory(item)">
                     <mat-icon class="material-icons-outlined">info</mat-icon>
                     <span>Booking details</span>
                  </button>
                  <button mat-menu-item *ngIf="item.bookingStatus == 4 && (isOwner || interestType != '4')" (click)="openInvoiceForHistory(item)">
                     <mat-icon class="material-icons-outlined">badge</mat-icon>
                     <span>Invoice</span>
                  </button>
                  <!-- <button mat-menu-item (click)="cancelBookingForHistory(item)" *ngIf="(((item.bookingStatus == 0 || item.bookingStatus == 1 || item.bookingStatus == 2 || item.bookingStatus == 5)) && (item.toshowOptions == 1) && (isOwner))">
                     <mat-icon class="material-icons-outlined">cancel</mat-icon>
                     <span>Cancel booking</span>
                  </button> -->
                  <button mat-menu-item *ngIf="(!item.customerInfo.hash_id || item.customerInfo.hash_id == 'null') && isOwner" (click)="deleteBookingForHistory(item)">
                  <mat-icon class="material-icons-outlined">delete</mat-icon>
                  <span>Delete booking</span>
                  </button>
               </div>

                  <div *ngIf="item.data_type == 2">

                     <button mat-menu-item   (click)="changeAttendanceStatus(1,item)" *ngIf="item.bookingStatus == 0 || item.bookingStatus == null || item.bookingStatus == 'null'" [disabled]="!isOwner && interestType == '4'">
                     <mat-icon class="material-icons-outlined">check_circle</mat-icon>
                     <span>Mark as present</span>
                     </button>
                  
                     <button mat-menu-item  (click)="changeAttendanceStatus(0,item)" *ngIf="item.bookingStatus == 1 || item.bookingStatus == null || item.bookingStatus == 'null'" [disabled]="!isOwner && interestType == '4'">
                     <mat-icon class="material-icons-outlined">cancel</mat-icon>
                     <span>mark as absent</span>
                     </button>
                     <button mat-menu-item  *ngIf="item.bookingStatus == 0 || item.bookingStatus == 1" (click)="deleteAttendance(item)" [disabled]="!isOwner && interestType == '4'">
                     <mat-icon class="material-icons-outlined">delete</mat-icon>
                     <span>Delete attendance</span>
                     </button>
                  
            
               </div>
         </mat-menu>
         </div>
         
         
         
         <p class="booking-meta">
            <span class="label">Assigned to: </span> <span class="value">{{item.employeeName}}</span>
         </p>
         <p class="booking-meta">
            <span class="label">Service mode: </span> <span class="value">{{item.booking_type}}</span>
         </p>
         <p class="booking-meta">
            <span class="label">Status: </span>
            <span class="value" >{{item.bookingStat}}</span>
            <span class="label" *ngIf="item.paymentStat && item.paymentStat != '---'">, Payment: </span> <span class="value"  *ngIf="item.paymentStat && item.paymentStat != '---'">{{item.paymentStat}}</span>
         </p>
         <p class="booking-meta" *ngIf="item.booking_date">
            <span class="value">{{item.booking_date ? (item.booking_date | date) : '---'}} </span>
         </p>
      
         </div>

            <div class="arrow_iocn_x">
    <mat-icon>arrow_forward</mat-icon>
  </div>
      </mat-card>
</div>
</div>
   </div>





  
  <!-- placeholder html start -->
  <div class="placeholder_started" *ngIf="!loader && messageList.length == 0 && processType == 3 && selectedValue == '2'">
        <div class="row">
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/bookings-pp.png">
                 </div>
                 <mat-card-title>No booking to show.</mat-card-title>
                 <mat-card-content>All the bookings will appear here between the selected date range. It seems you haven't started operations or check the selected dates.
                </mat-card-content>
                 <!-- <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="openvideo()">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div> -->
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="/assets/images/new-booking.png">
                 </div>
                 <mat-card-title>How to create a new booking?</mat-card-title>
                 <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on creating new booking against a business. You can check this video as well. 

                </mat-card-content>
                <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="openvideo()">
                     <mat-icon>play_arrow</mat-icon>
                     Watch video
                  </button>
               </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Facing any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in getting the list of bookings or issue with managing them, contact our support team. 
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary"  (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
  </div> 

  <!-- placeholder html end -->   
   <!-- --------SESSION BOOKINGS END -------------->






      <!-- --------ATTENDANCE START -------------->
    



 <div class="busroy" *ngIf="!loader && attendanceList.length > 0 && processType == 3 && selectedValue == '3'">
   <div class="row">
      <div class="col-sm-4" *ngFor="let item of attendanceList">
   <mat-card >
      <div class="booking-card" >
      <div class="booking-header">
         
         <div class="left-section" style="position: relative;">


            <mat-icon
            *ngIf="(!item.customerInfo.imgThumbUrl || item.customerInfo.imgThumbUrl == 'null') && item.data_type == 2"
            [class.cancelled]="(item.bookingStatus == 0 )&& item.data_type == 2"
      [class.new-booking]="(item.bookingStatus == 1 && !item.session_status ) && item.data_type == 2"
      [class.under-process]="(item.bookingStatus == 1 && (item.session_status ==  2 || item.session_status ==  1)) && item.data_type == 2"
      [class.completed]="(item.bookingStatus == 1 && item.session_status ==  3) && item.data_type == 2"
               class="status-icon"></mat-icon>
            <mat-icon
            *ngIf="item.customerInfo.imgThumbUrl && item.customerInfo.imgThumbUrl != 'null' && item.data_type == 2"
            [class.cancelled]="(item.bookingStatus == 0 )&& item.data_type == 2"
      [class.new-booking]="(item.bookingStatus == 1 && !item.session_status ) && item.data_type == 2"
      [class.under-process]="(item.bookingStatus == 1 && (item.session_status ==  2 || item.session_status ==  1)) && item.data_type == 2"
      [class.completed]="(item.bookingStatus == 1 && item.session_status ==  3) && item.data_type == 2"
               class="status-icon"></mat-icon>



            <div class="booking-initial" *ngIf="!item.customerInfo.imgThumbUrl || item.customerInfo.imgThumbUrl == 'null'">{{item.customerName.slice(0,1)}}</div>
            <img class="booking-initial-img img-fluid rounded-circle" [src]="item.customerInfo.imgThumbUrl" alt="" *ngIf="item.customerInfo.imgThumbUrl && item.customerInfo.imgThumbUrl != 'null'" onerror="this.src='../../../../assets/images/user-avatar.svg'">
            <div class="booking-details">
            <h3 class="booking-name">{{item.customerName}}</h3>

            <!-- <h2 class="booking-number" *ngIf="item.appointment_no">#{{item.appointment_no}}</h2> -->
            <p class="booking-number">  <span class="bookingstar">{{item.bookingStartTime}} - {{item.bookingEndTime}}</span></p>
            </div>
         </div>
         <button mat-icon-button [matMenuTriggerFor]="menu" class="custom-icon-button">
            <mat-icon>more_vert</mat-icon>
         </button>
         <mat-menu #menu="matMenu">
            

               <div *ngIf="item.data_type == 2">

                  <button mat-menu-item   (click)="changeAttendanceStatus(1,item)" *ngIf="(item.bookingStatus == 0 || item.bookingStatus == null || item.bookingStatus == 'null') && (isOwner && item.session_status != 3)" >
                  <mat-icon class="material-icons-outlined">check_circle</mat-icon>
                  <span>Mark as present</span>
                  </button>
               
                  <button mat-menu-item  (click)="changeAttendanceStatus(0,item)" *ngIf="(item.bookingStatus == 1 || item.bookingStatus == null || item.bookingStatus == 'null') && (isOwner && item.session_status != 3)" >
                  <mat-icon class="material-icons-outlined">cancel</mat-icon>
                  <span>mark as absent</span>
                  </button>
                  <button mat-menu-item  *ngIf="item.bookingStatus == 0 || item.bookingStatus == 1" (click)="deleteAttendance(item)" [disabled]="!isOwner && interestType == '4' && item.session_status == 3">
                  <mat-icon class="material-icons-outlined">delete</mat-icon>
                  <span>Delete attendance</span>
                  </button>
               
         
            </div>
      </mat-menu>
      </div>
      
      
      
      <p class="booking-meta">
         <span class="label">Assigned to: </span> <span class="value">{{item.employeeName}}</span>
      </p>
      <p class="booking-meta">
         <span class="label">Service mode: </span> <span class="value">{{item.booking_type}}</span>
      </p>
      <p class="booking-meta">
         <span class="label">Status: </span>
         <span class="value" >{{item.bookingStat}}</span>
         <span class="label" *ngIf="item.paymentStat && item.paymentStat != '---'">, Payment: </span> <span class="value"  *ngIf="item.paymentStat && item.paymentStat != '---'">{{item.paymentStat}}</span>
      </p>
      <p class="booking-meta" *ngIf="item.booking_date">
         <span class="value">{{item.booking_date ? (item.booking_date | date) : '---'}} </span>
      </p>
   
      </div>
   </mat-card>
   </div>
   </div>
</div>






<!-- placeholder html start -->
<div class="placeholder_started" *ngIf="!loader && attendanceList.length == 0 && processType == 3 && selectedValue == '3'">
     <div class="row">
       <div class="col-sm-4">
         <div class="dashboard_new">
           <mat-card appearance="outlined">
               <div class="upload_sectio">
              <div class="icm_img">
                 <img src="./assets/images/bookings-pp.png">
              </div>
              <mat-card-title>No attendance list to show here.</mat-card-title>
              <mat-card-content>All the attendances will appear here between the selected date range. It seems you haven't started operations or check the selected dates.
             </mat-card-content>
              <!-- <div class="watch_vc_btn">
                 <button mat-stroked-button color="primary" (click)="openvideo()">
                    <mat-icon>play_arrow</mat-icon>
                    Watch video
                 </button>
              </div> -->
              </div>
           </mat-card>
        </div>
       </div>
       <div class="col-sm-4">
         <div class="dashboard_new">
           <mat-card appearance="outlined">
               <div class="upload_sectio">
              <div class="icm_img">
                 <img src="/assets/images/new-booking.png">
              </div>
              <mat-card-title>How attendance work?</mat-card-title>
              <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on marking present and absent against members. You can check this video as well. 

              </mat-card-content>
             <div class="watch_vc_btn">
               <button mat-stroked-button color="primary" (click)="openVideoForAttendance()">
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
               </button>
            </div>
              </div>
           </mat-card>
        </div>
       </div>
       <div class="col-sm-4">
         <div class="dashboard_new">
           <mat-card appearance="outlined">
               <div class="upload_sectio">
              <div class="icm_img">
                 <img src="./assets/images/helpsupport.png">
              </div>
              <mat-card-title>Facing any issue?</mat-card-title>
              <mat-card-content>For any difficulties in getting the list of bookings or issue with managing them, contact our support team. 
             </mat-card-content>
              <div class="watch_vc_btn">
                 <button mat-stroked-button color="primary"  (click)="opencontact()">
                    <mat-icon>support_agent</mat-icon>
                    Contact support 
                 </button>
              </div>
              </div>
           </mat-card>
        </div>
       </div>
     </div>
</div> 

<!-- placeholder html end -->   
<!-- --------ATTENDANCE END -------------->



<!-- QUERIES START -->
<div
  class="busroy"
  *ngIf="!loader && queryData.length > 0  && processType == 1  && interestStatus == '2'"
>
  <div class="row">
    <div
      class="col-sm-4"
      *ngFor="let item of queryData"
      (click)="viewDetailsforservicequery(item)"
    >
      <mat-card>
        <div class="booking-card">
          <div class="booking-header">
            <div class="left-section" style="position: relative">
              <mat-icon
                [class.new-booking]="item.status == 1"
                [class.under-process]="item.status == 2"
                [class.completed]="item.status == 3"
                class="status-icon"
              ></mat-icon>
              <div
                class="booking-initial"
                
              >
                {{ item.name.slice(0, 1) }}
              </div>
              <!-- <img
                class="booking-initial-img img-fluid rounded-circle"
                [src]="item.image_thumb_url"
                alt=""
                *ngIf="item.image_thumb_url && item.image_thumb_url != 'null'"
                onerror="this.src='../../../../assets/images/user-avatar.svg'"
              /> -->
              <div class="booking-details">
                <h3 class="booking-name">{{ item.name }}</h3>
                <p class="booking-number">
                  <span
                    class="bookingstar"
                    style="font-size: 14px; color: #888"
                    >{{ item.phone }}</span
                  >
                </p>
              </div>
            </div>

            <!-- <button mat-icon-button [matMenuTriggerFor]="menu" class="custom-icon-button">
         <mat-icon>more_vert</mat-icon>
       </button> -->
          </div>

          <p class="booking-meta">
            <!-- <span class="label">Phone: </span> <span class="value"></span>,  -->
            <span class="label">Status: </span>
            <span class="value">{{ item.item_status }}</span>
          </p>
          <p class="booking-meta">
            <!-- <span class="label">Phone: </span> <span class="value"></span>,  -->
            <span class="label">Service mode: </span>
            <span class="value">{{ item.s_mode }}</span>
          </p>
         
          <p class="booking-meta">
            <span class="value">{{ item.creation_time | date : 'MMM d, y, h:mm a' : 'UTC' }}</span>
          </p>
        </div>
        <div class="arrow_iocn_x">
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </mat-card>
    </div>
  </div>
</div>

<!-- placeholder html start -->
<div
  class="placeholder_started"
 *ngIf="!loader && queryData.length == 0  && processType == 1  && interestStatus == '2'"
>
  <div class="row">
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/query-s1.jpg" />
            </div>
            <mat-card-title>No service queries to show.</mat-card-title>
            <mat-card-content
              >All the queries will appear here between the selected date range. It seems you haven't started operations or check the selected dates.
            </mat-card-content>
            <!-- <div class="watch_vc_btn" *ngIf="interestType != '4'">
                     <button mat-stroked-button color="primary"  (click)="addNewInterest()">
                        <mat-icon>add</mat-icon>
                        Add new query 
                     </button>
                  </div> -->
          </div>
        </mat-card>
      </div>
    </div>
<!-- 
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="/assets/images/new-booking.png" />
            </div>
            <mat-card-title>How to create a new query?</mat-card-title>
            <mat-card-content
              >Check our
              <span
                class="ghtunderline"
                (click)="openLink('https://lookzup.com/help')"
              >
                help document
              </span>
              on creating new query against a business. You can check this video
              as well.
            </mat-card-content>
            <div class="watch_vc_btn">
              <button mat-stroked-button color="primary" (click)="openvideo()">
                <mat-icon>play_arrow</mat-icon>
                Watch video
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div> -->
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card appearance="outlined">
          <div class="upload_sectio">
            <div class="icm_img">
              <img src="./assets/images/helpsupport.png" />
            </div>
            <mat-card-title>Facing any issue?</mat-card-title>
            <mat-card-content
              >For any difficulties contact our support team.
            </mat-card-content>
            <div class="watch_vc_btn">
              <button
                mat-stroked-button
                color="primary"
                (click)="opencontact()"
              >
                <mat-icon>support_agent</mat-icon>
                Contact support
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
<!-- placeholder html end -->

<!-- QUERIES END -->
